import { render, staticRenderFns } from "./PhilosophyForm.vue?vue&type=template&id=1a2ef44a&scoped=true&"
import script from "./PhilosophyForm.vue?vue&type=script&lang=js&"
export * from "./PhilosophyForm.vue?vue&type=script&lang=js&"
import style0 from "./PhilosophyForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PhilosophyForm.vue?vue&type=style&index=1&id=1a2ef44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ef44a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VForm,VIcon,VRow,VSpacer})
